import {Wrapper} from "../components/wrapper/wrapper";
import Dashboard from "../pages/dashboard";

export default function Index(){
	return (
		<Wrapper>
			<Dashboard/>
		</Wrapper>
	);
}